/**
 * SoulumoFooter — the quiet footer that lives at the bottom of every
 * public Soulumo route. Mar 6 2026.
 *
 * Renders: Support · Wellbeing · Terms · Privacy · version.
 * Minimal, uppercase tracking, Manrope, low contrast — deliberately
 * out of the way but always reachable.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BetaPulseModal from "./BetaPulseModal";

const TOK = {
  creamMist: "rgba(245,224,173,0.42)",
  creamDim: "rgba(245,224,173,0.60)",
  goldMist: "rgba(231,201,138,0.24)",
};

export default function SoulumoFooter() {
  const nav = useNavigate();
  const [showFeedback, setShowFeedback] = useState(false);
  const items = [
    { label: "Wellbeing",  path: "/soulumo/wellbeing" },
    { label: "Feedback",   action: "feedback" },
    { label: "Support",    path: "mailto:hello@soulumo.app", external: true },
    { label: "Terms",      path: "/soulumo/terms" },
    { label: "Privacy",    path: "/soulumo/privacy" },
  ];
  const onClick = (it) => {
    if (it.action === "feedback") setShowFeedback(true);
    else if (it.external) window.location.href = it.path;
    else nav(it.path);
  };

  return (
    <footer
      className="relative z-10 px-5 pt-10 pb-8 border-t"
      style={{ borderColor: TOK.goldMist }}
      data-testid="soulumo-footer"
    >
      <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div
          className="text-[0.55rem] uppercase tracking-[0.32em]"
          style={{ color: TOK.creamMist, fontFamily: '"Manrope", sans-serif' }}
        >
          Soulumo · soulumo.app · v0.1
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {items.map((it) => (
            <button
              key={it.label}
              onClick={() => onClick(it)}
              data-testid={`soulumo-footer-${it.label.toLowerCase()}`}
              className="uppercase transition-colors"
              style={{
                color: TOK.creamDim,
                fontFamily: '"Manrope", sans-serif',
                fontSize: "0.58rem",
                letterSpacing: "0.28em",
              }}
            >
              {it.label}
            </button>
          ))}
        </nav>
      </div>
      <BetaPulseModal
        open={showFeedback}
        onClose={() => setShowFeedback(false)}
        source="footer-link"
      />
    </footer>
  );
}
